import styled from '@emotion/styled';
import { formatCurrency } from 'src/components/helpers';
import { sillaValue } from './LegadoSelectChairs';
import { screenSizes } from 'src/assets/styles/Literals';

const LegadoContainer = styled.div`
  min-height: 100vh;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;

  * {
    font-family: 'Geist', sans-serif !important;
  }

  .header-banner {
    background: #1a3b64;
    border-radius: 30px;
    margin-bottom: 80px;
    position: relative;
    overflow: hidden;
    width: 1030px;
    height: 215px;
    text-align: left;
    font-size: 32px;
    font-weight: 800;
    line-height: 1.2;
    text-transform: uppercase;
    letter-spacing: -0.5px;

    .header-banner-content {
      position: absolute;
      top: 0;
      left: 0;
      line-height: 1.2;
      text-transform: uppercase;
      letter-spacing: -0.5px;
      color: #edd4be;
      padding: 40px 30px;
      width: 76%;
      p {
        font-size: 45px;
        font-weight: 600;
        line-height: 100%;
      }
    }
    .header-banner-image {
      position: absolute;
      top: 0;
      right: 30px;
      width: 250px;
      height: 240px;
      background: url('https://comunidadmde.s3.us-east-1.amazonaws.com/resources/legado/silla_desvanecida.png')
        no-repeat center;
      background-size: contain;
    }

    @media (max-width: 1050px) {
      width: 100%;
      .header-banner-content {
        width: 95%;
      }
    }
    @media (max-width: ${screenSizes.tablet}) {
      height: 260px;
      .header-banner-content {
        p {
          font-size: 32px;
        }
      }
    }
  }

  .sub-heading {
    color: #1a3b64;
    font-size: 30px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 50px;
    margin-top: 0;
    text-transform: uppercase;
    letter-spacing: 10%;
  }

  .cards-container {
    display: flex;
    gap: 40px;
    max-width: ${screenSizes.desktop};
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 100px;
  }

  .donation-card {
    background: #1a3b64;
    border-radius: 25px;
    padding: 50px 30px;
    width: 320px;
    height: 450px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    position: relative;

    &:hover {
      cursor: pointer;
      transform: translateY(-8px);
      box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
    }

    &.variant-light {
      background: #b3e0ff;
    }

    &.variant-black {
      background: #000000;
    }

    .card-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 20px;
      font-weight: 600;
      text-align: center;
      h2 {
        font-size: 38px;
        font-weight: 700;
        line-height: 1.1;
        margin: 0;
        letter-spacing: 0px;
      }
      p {
        font-size: 16px;
        font-weight: 400;
        line-height: 1.5;
        padding: 10px 0;
        margin: 0;
      }
    }

    &.variant-light .card-content {
      color: #1a3b64;
    }

    .donate-button {
      background: #b0ddff;
      color: #1a3b64;
      border: none;
      border-radius: 30px;
      padding: 10px 15px;
      font-size: 22px;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      transition: all 0.3s ease;
      text-decoration: none;
      width: 100%;
      text-transform: uppercase;
      letter-spacing: 0.5px;

      &:hover {
        transform: scale(1.03);
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
      }

      .arrow-icon {
        width: 24px;
        height: 24px;
        background: #1a3b64;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: white;
        font-weight: bold;
      }
    }

    &.variant-light {
      padding-top: 40px;
      .donate-button {
        background: #1a3b64;
        color: #b0ddff;

        .arrow-icon {
          background: #b0ddff;
          color: #1a3b64;
        }
      }
    }

    &.variant-black .donate-button {
      background: #b0ddff;
      color: #1a3b64;

      .arrow-icon {
        background: #1a3b64;
        color: white;
      }
    }

    &.full-width {
      width: 655px;
      min-height: 200px;
      height: auto;
      padding: 30px;
      background: linear-gradient(135deg, #1a3b64 0%, #2c5a8a 100%);
      border: 2px solid #b0ddff;
      box-shadow: 0 10px 30px rgba(26, 59, 100, 0.2);
      position: relative;

      .card-content {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        text-align: left;
        height: 100%;
        padding-bottom: 70px;

        h2 {
          font-size: 36px;
          margin-bottom: 12px;
          line-height: 1.1;
        }

        p {
          font-size: 16px;
          padding: 0;
          margin: 0;
          line-height: 1.4;
          max-width: 100%;
        }
      }

      .donate-button {
        position: absolute;
        bottom: 20px;
        right: 20px;
        width: auto;
        min-width: 200px;
        padding: 10px 20px;
        font-size: 18px;
        background: #b0ddff;
        color: #1a3b64;
        border: 2px solid #b0ddff;

        &:hover {
          background: transparent;
          color: #b0ddff;
          border-color: #b0ddff;
          transform: scale(1.02);
        }

        .arrow-icon {
          background: #1a3b64;
          color: white;
        }
      }

      @media (max-width: ${screenSizes.laptop}) {
        width: 100%;
        max-width: 655px;
      }

      @media (max-width: ${screenSizes.tablet}) {
        padding: 25px 20px;
        min-height: auto;

        .card-content {
          padding-bottom: 0;

          h2 {
            font-size: 28px;
            margin-bottom: 10px;
          }

          p {
            font-size: 15px;
          }
        }

        .donate-button {
          position: relative;
          bottom: auto;
          right: auto;
          width: 100%;
          min-width: auto;
          margin-top: 20px;
          font-size: 16px;
          padding: 12px 20px;
        }
      }

      @media (max-width: ${screenSizes.mobile}) {
        padding: 20px 15px;

        .card-content {
          padding-bottom: 0;

          h2 {
            font-size: 24px;
            margin-bottom: 8px;
          }

          p {
            font-size: 14px;
          }
        }

        .donate-button {
          font-size: 14px;
          padding: 10px 15px;
        }
      }
    }
  }

  .bottom-section {
    display: flex;
    max-width: 1000px;
    width: 100%;
    gap: 30px;
    align-items: center;

    @media (max-width: ${screenSizes.tablet}) {
      flex-direction: column;
    }
    .image-placeholder {
      background: url('https://comunidadmde.s3.us-east-1.amazonaws.com/resources/legado/image_legado.png');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 25px;
      width: 40%;
      height: 320px;
      flex-shrink: 0;

      @media (max-width: ${screenSizes.tablet}) {
        width: 100%;
        height: 350px;
      }
    }

    .content-section {
      flex: 1;
      color: #1a3b64;
      .description-text {
        font-size: 20px;
        line-height: 26px;
        margin-bottom: 40px;
        line-height: 26px;
        color: #333333;
        font-weight: 400;
      }
      .main-heading {
        font-size: 45px;
        font-weight: 600;
        line-height: 1.1;
        color: #1a3b64;
        margin: 0;
        text-transform: uppercase;
        letter-spacing: 0px;

        @media (max-width: ${screenSizes.tablet}) {
          font-size: 42px;
        }
      }
    }
  }
`;

const LegadoSelectDonation = ({ setCategory, setModalCheckInOpen }) => {
  return (
    <LegadoContainer>
      <div className="header-banner">
        <div className="header-banner-content">
          <p>SOÑAMOS CON 5000 PERSONAS MÁS CONOCIENDO A JESÚS CADA FIN DE SEMANA</p>
        </div>
        <div className="header-banner-image"></div>
      </div>

      <h2 className="sub-heading">SÉ PARTE DE ALGO MÁS GRANDE</h2>

      <div className="cards-container">
        <div className="donation-card" onClick={() => setCategory('chairs')}>
          <div className="card-content">
            <h2>Una o más sillas</h2>
            <p>
              Comprométete con una o más sillas con una donación única de&nbsp;
              {formatCurrency(sillaValue)} por silla.
            </p>
            <p>Cada una representa una vida transformada por un encuentro con Jesús.</p>
          </div>
          <button className="donate-button">
            QUIERO DONAR
            <div className="arrow-icon">→</div>
          </button>
        </div>

        <div
          className="donation-card variant-light"
          onClick={() => setModalCheckInOpen('chairsToCommit')}
        >
          <div className="card-content">
            <h2>Una silla o más en diferentes donaciones</h2>
            <p>
              Puedes donar en diferentes momentos y con distintos valores hasta completar las sillas
              que deseas donar. Cada silla representa una vida transformada por un encuentro con
              Jesús.
            </p>
          </div>
          <button className="donate-button">
            QUIERO DONAR
            <div className="arrow-icon">→</div>
          </button>
        </div>

        <div
          className="donation-card variant-black"
          onClick={() => setModalCheckInOpen('promiseFormValue')}
        >
          <div className="card-content">
            <h2>Comprométete a donar</h2>
            <p>
              Dona sin importar el valor. Cada donación suma y ayuda a construir legado,
              transformando vidas por un encuentro con Jesús.
            </p>
          </div>
          <button className="donate-button">
            QUIERO DONAR
            <div className="arrow-icon">→</div>
          </button>
        </div>
        <div
          className="donation-card full-width"
          onClick={() => setModalCheckInOpen('promiseForm')}
        >
          <div className="card-content">
            <h2>Ver mis donaciones</h2>
            <p>Ver todas tus donaciones y el avance total de la donación.</p>
          </div>
          <button className="donate-button">
            VER MIS DONACIONES
            <div className="arrow-icon">→</div>
          </button>
        </div>
      </div>

      <div className="bottom-section">
        <div className="image-placeholder" />
        <div className="content-section">
          <p className="description-text">
            Cada silla representa una vida transformada por Jesús, una familia restaurada, un alma
            siendo libre. Cada asiento es una oportunidad para transformar nuestra amada Medellín,
            para construir un legado invaluable a nuestras generaciones y para ser parte de un
            momento histórico dentro del plan eterno de Dios.
          </p>
          <h1 className="main-heading">
            COMUNIDAD
            <br />
            CONSTRUYE LEGADO
          </h1>
        </div>
      </div>
    </LegadoContainer>
  );
};

export default LegadoSelectDonation;
